<div class="dashboard" [class.paddingLeft]="isSidebarExpanded">
  <div *ngIf="activeTab === 'overview'" class="p-4">

    <!-- Top Cards Row -->
    <div class="mb-3 d-flex justify-content-between align-items-start flex-wrap">
      <div>
        <p class="fs-18 mb-2 fw-600">Dashboard</p>
        <span class="text-muted small">Overview of medical evidence request and collections​</span>
      </div>
      <div class="d-flex gap-2">
        <!-- Buttons -->
        <button class="primaryBtn" (click)="openRequestME()">
          New ME Request
        </button>
        <button class="secondaryBtn" (click)="openBulkUploadModal()">
          Applicants Bulk Upload
        </button>
      </div>
    </div>

    <!-- Dashboard Cards -->
    <div class="row g-4">
      <div class="col-md-12 p-2">
        <div class="row justify-content-between">
          <div class="col custom-col mb-3" *ngFor="let card of dashboardCards2; let i = index">

            <div class="dashboard-card p-4" [ngClass]="card.color" (click)="onCardClick(i); goToMembersTab()"
              (mouseenter)="onCardHover(card)">
              <div class="d-flex flex-column">
                <p class="fw-600" style="margin-bottom: 10px;font-size: 22px;">
                  {{ card.value | countUp:card.hoverTrigger$:1000 | async }}
                </p>
                <h5>{{ card.title }}</h5>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Row: Latest Applicants & Chart -->
    <div class="row no-gutters gx-3">
      <!-- Left: Latest Applicants (50%) -->
      <div class="col-md-6">
        <div class="custom-card h-100">
          <div class="card-header">
            <div class="d-flex justify-content-between">
              <p class="mb-0 fs-13 fw-500">Latest Applicants</p>
              <p (click)="goToPatients()" class="see-all cursor-pointer">
                See all
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 2 16 16">
                  <path fill="#0075C9"
                    d="m5.157 13.069l4.611-4.685a.546.546 0 0 0 0-.768L5.158 2.93a.55.55 0 0 1 0-.771a.53.53 0 0 1 .759 0l4.61 4.684a1.65 1.65 0 0 1 0 2.312l-4.61 4.684a.53.53 0 0 1-.76 0a.55.55 0 0 1 0-.771" />
                </svg>
              </p>
            </div>
          </div>
          <div class="left-panel mt-3">
            <ng-container *ngIf="patientsList && patientsList.length > 0; else noPatients">
              <ul class="patient-list">
                <li *ngFor="let patient of patientsList; let i = index" class="patient-item animate"
                  (click)="onReqClick(patient)">
                  <div class="patient-avatar">
                    {{ patient.firstName | initials: patient.lastName}}
                  </div>
                  <div class="patient-info">
                    <h5 class="mb-1">{{ patient.firstName }} {{ patient.lastName }}</h5>
                    <p class="mb-0 text-muted">DOB: {{ patient.dateOfBirth }}</p>
                    <p class="mb-0 text-muted fs-11">
                      Requested on: {{ patient.createdOn | date: 'dd-MM-yyyy HH:mm' }}
                    </p>
                  </div>
                  <div class="patient-status">
                    <app-status-lables
                      [status]="patient.status ? patient.status == 'SUBMITTED' ? 'RECEIVED' : patient.status : 'OPEN'"
                      [entityType]="enumEntityType.INSURER">
                    </app-status-lables>
                    <div class="last-updated text-muted fs-11 mt-1">
                      Last Updated: {{ patient.lastUpdatedOn | date: 'dd-MM-yyyy HH:mm' }}
                    </div>
                  </div>
                </li>
              </ul>
            </ng-container>
            <ng-template #noPatients>
              <app-no-data-found></app-no-data-found>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Right: Chart (50%) -->
      <div class="col-md-6">
        <div class="custom-card h-100">
          <div class="card-header">
            <p class="fs-13 fw-500" style="margin:0">Last 6 Months Overview</p>
          </div>
          <div class="sleep-quality-container">
            <div class="sleep-chart-section">
              <div class="chart-wrapper">
                <canvas baseChart [data]="chartData" [options]="chartOptions" [type]="chartType"></canvas>
              </div>
            </div>

            <div class="sleep-metrics-grid">
              <div class="metric-box">
                <p class="fs-18">{{ sentPendingRequestsCount }}</p>
                <p class="fs-13" [style.color]="sentPendingRequestsColorThick">Sent / Pending Requests</p>
              </div>
              <div class="metric-box">
                <p class="fs-18">{{ moreInfoRequestedCount }}</p>
                <p class="fs-13" [style.color]="moreInfoRequestedColorThick">More Info Requested</p>
              </div>
              <div class="metric-box">
                <p class="fs-18">{{ medicalEvidenceReceivedCount }}</p>
                <p class="fs-13" [style.color]="medicalEvidenceReceivedColorThick">Medical Evidence Received</p>
              </div>
              <div class="metric-box">
                <p class="fs-18">{{ totalCount }}</p>
                <p class="fs-13" [style.color]="totalColorThick">Total Evidence Requests</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="activeTab === 'members'">
    <div class="members-list-section">
      <app-patient-table [from]="'dashboard'"></app-patient-table>
    </div>
  </div>
</div>